import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { ValueAdditionFiveType } from "../value-addition-five.entity";
import { ValueAdditionFiveDTO } from "./value-addition-five.dto";

export class ValueAddFiveTypeAdapter {
    convertDtoToEntity(dtoObj: ValueAdditionFiveDTO,  isUpdate: boolean = false ): ValueAdditionFiveType {
        try {
            const entityObj = new ValueAdditionFiveType();
            entityObj.valueAdditionFiveId = dtoObj.valueAdditionFiveId
            entityObj.code = dtoObj.code;
            entityObj.name = dtoObj.name;
            entityObj.remarks = dtoObj.remarks;
            entityObj.isActive=dtoObj.isActive==undefined?true:dtoObj.isActive;
            if (isUpdate){
                entityObj.updatedUser = dtoObj.updatedUser;
            }else {
                entityObj.isActive = true;
                entityObj.createdUser=dtoObj.createdUser;
            }
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: ValueAdditionFiveType): ValueAdditionFiveDTO {
        const foodTypeDetailsDTO= new ValueAdditionFiveDTO;
        foodTypeDetailsDTO.valueAdditionFiveId = employeeObject.valueAdditionFiveId;
        foodTypeDetailsDTO.code = employeeObject.code;
        foodTypeDetailsDTO.name = employeeObject.name;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}